// extracted by mini-css-extract-plugin
export default {"root":"_2iIlX","small":"_3JAoe","normal":"lJ4AG"};